/**
 * Created by Victor Rojo on 25/10/17.
 */
import { Component, Input} from '@angular/core';

@Component({
  selector: 'cnxn-loader',
  templateUrl: './loader.component.html',
  styleUrls: [ './loader.component.css'],
})

export class LoaderComponent {
}
